import { IContentProvider } from './types';
import LinkProvider from './providers/linkProvider';
import YoutubeProvider from './providers/youtubeProvider';

let _instance: ContentProviders;
export default class ContentProviders {
    _providers: IContentProvider[] = [];
    constructor() {
        if (_instance) {
            return _instance;
        } 
        // the order of providers is important.
        this._providers.push(new YoutubeProvider());
        this._providers.push(new LinkProvider());
        
        _instance = this;
    }

    getContent(resource: string): string {
        let newContent: string = '';
        for (const p of this._providers) {
            if (!newContent && p.isMatched(resource)) {
                newContent = p.getContent(resource);
                break;
            }
        }
        return newContent || resource;
    }
}
